import { render } from "./BahamasPage.vue?vue&type=template&id=792643b0&scoped=true"
import script from "./BahamasPage.vue?vue&type=script&lang=js"
export * from "./BahamasPage.vue?vue&type=script&lang=js"

import "./BahamasPage.vue?vue&type=style&index=0&id=792643b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792643b0"]])

export default __exports__